import StatsigWrapper from "./components/StatsigWrapper";
import { FeatureFlag } from "./constants";
import useIsStatsigLoading from "./hooks/useIsStatsigLoading";
// Re-export Statsig-provided hooks for app-wide usage
export {
  useFeatureGate,
  useDynamicConfig,
  useStatsigClient,
} from "@statsig/react-bindings";
export { FeatureFlag, StatsigWrapper, useIsStatsigLoading };
